export default "__VITE_ASSET__CgbHQ222__"